import { Link } from "react-router-dom";
import { Menu } from "lucide-react";
import { PollinatorLogo } from "@themes/pollinator/ui/PollinatorLogo";
import { Button } from "@themes/pollinator/ui/Button";
import { Sheet } from "@themes/pollinator/ui/Sheet";

export type Props = {
  isMobileMenuOpen: boolean;
  closeMobileMenu: () => void;
  onMenuClick?: () => void;
  children?: React.ReactNode;
};

export function PlatformHeader({
  onMenuClick,
  closeMobileMenu,
  isMobileMenuOpen,
  children,
}: Props) {
  return (
    <>
      <header className="flex flex-row items-center justify-between bg-brand-50 fixed top-0 left-0 right-0 z-40 h-14 px-4 border-b border-brand-800 md:hidden">
        <Link to="/dashboard" data-testid="platform-header-home">
          <PollinatorLogo size="sm" />
        </Link>
        <Button
          variant="ghost"
          iconComponent={Menu}
          onClick={onMenuClick}
          data-testid="platform-header-menu-button"
        />
      </header>
      <Sheet
        isOpen={isMobileMenuOpen}
        onClose={closeMobileMenu}
        className="p-4"
      >
        {children}
      </Sheet>
    </>
  );
}

export default PlatformHeader;

